module.exports = __webpack_public_path__ + "static/media/PastEventsMobile.b56a726c.jpg";